export enum OrderState {
    Open = 'open',
    InProgress = 'inProgress',
    Cancelled = 'cancelled',
    Closed = 'closed',
}
